import { MobileBottomSheet } from "@/components/mobileBottomSheet/mobileBottomSheet";
import PspTextInput from "@/components/pspTextInput/pspTextInput";
// eslint-disable-next-line max-len
import { useAddGiustificativoBottomSheet } from "./addGiustificativoBottomSheet/useAddGiustificativoBottomSheet";
import { showTranslated, translate } from "@/config/translator";
import { Attendance } from "@/api/openapi";
import { Dispatch, SetStateAction } from "react";

type AddGiustificativoBottomSheetProps = {
  isOpen: boolean;
  onClose: () => void;
  employeeAttendance: Attendance;
  setIsSaving: Dispatch<SetStateAction<boolean>>;
};

export function AddGiustificativoBottomSheet({
  isOpen,
  onClose,
  employeeAttendance,
  setIsSaving,
}: AddGiustificativoBottomSheetProps) {
  const {
    lang,
    searchQuery,
    onCloseWrapper,
    giustificativiSearchResults,
    onChangeSearchQuery,
    onAddGiustificativo,
  } = useAddGiustificativoBottomSheet({
    onClose,
    employeeAttendance,
    setIsSaving,
  });

  return (
    <MobileBottomSheet
      title={translate("selectGiustificativo", lang)}
      isOpen={isOpen}
      onClose={onCloseWrapper}
    >
      <div className="flex flex-col gap-4">
        <PspTextInput
          value={searchQuery}
          onChange={onChangeSearchQuery}
          labelString={translate("search", lang)}
        />
        <div className="flex flex-col gap-2">
          {giustificativiSearchResults?.map((searchResult) => (
            <button
              onClick={() => onAddGiustificativo(searchResult)}
              className="p-3 rounded-md shadow-md text-left"
            >
              {searchResult.type} -{" "}
              {showTranslated(searchResult.description, lang)}
            </button>
          ))}
        </div>
      </div>
    </MobileBottomSheet>
  );
}
